const languagesMap = new Map<String, number>([["en", 1], ["es", 2], ["pt", 3]])

export default languagesMap;
